import React                  from 'react';
import PropTypes              from 'prop-types';
import ActorAvatar                   from './ActorAvatar';

class ActorsFromPost extends React.Component {

	/**
	 * @return {{offset: number, rowSize: number}}
	 */
	static getInitialState() {
		return {
			offset:  0,
			rowSize: ActorsFromPost.ROW_MAX_SIZE,
		};
	}

	/**
	 * @param {Object} props
	 */
	constructor(props) {
		super(props);
		this.container = null;
		this.state     = ActorsFromPost.getInitialState();

        this.onPrevious   = this.onPreviousHandler.bind(this);
        this.onNext       = this.onNextHandler.bind(this);
        this.setContainer = this.setContainerHandler.bind(this);
        this.resize       = this.resizeHandler.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.resize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.resizeHandler.bind(this));
	}

	resizeHandler() {
		this.setState({
			rowSize: this.calculateRowSize(),
		});
	}

	/**
	 * @param {HTMLElement} element
	 */
	setContainerHandler(element) {
		this.container = element;

		this.setState({
			rowSize: this.calculateRowSize(),
		});
	}

	/**
	 * @return {number}
	 */
	calculateRowSize() {
		// only show 2 on mobile
		if (this.props.isMobile) {
			return ActorsFromPost.ROW_MOBILE_SIZE;
		}

		// if not available - show max
		if (null === this.container) {
			return ActorsFromPost.ROW_MAX_SIZE;
		}

		return this.props.isCalendar ? 6 : Math.round(this.container.clientWidth / (1.2 * ActorsFromPost.AVATAR_CARD_WIDTH));
	}

	/**
	 * @param {Event} e
	 */
	onPreviousHandler(e) {
		e.preventDefault();

		// do nothing if disabled
		if (Array.prototype.indexOf.call(e.target.classList, '-is-disabled') !== -1) {
			return;
		}

		this.setState({
			offset: this.state.offset - 1,
		});
	}

	/**
	 * @param {Event} e
	 */
	onNextHandler(e) {
		e.preventDefault();

		// do nothing if disabled
		if (Array.prototype.indexOf.call(e.target.classList, '-is-disabled') !== -1) {
			return;
		}

		this.setState({
			offset: this.state.offset + 1,
		});
	}

	/**
	 * @return {*}
	 */
	render() {
		// don't render empty
		if (this.props.models.length === 0) {
			return null;
		}

		const arrowClass = 'girls-from-this-post__list-left icon -icon-single-arrow',
		      enableNext = this.props.models.length - this.state.offset > this.state.rowSize,
		      enablePrev = this.state.offset > 0,
		      previous   = <i className={arrowClass + '-left-line' + (enablePrev ? '' : ' -is-disabled')} onClick={this.onPrevious} />,
		      next       = <i className={arrowClass + '-right-line' + (enableNext ? '' : ' -is-disabled')} onClick={this.onNext} />,
		      isLong     = this.props.models.length > this.state.rowSize,
		      avatars    = this.props.models.map((m, idx) => (
			      <ActorAvatar
				      name={m.name}
				      age={m.age}
				      url={m.url}
				      isOnline={m.isOnline}
				      image={m.image}
				      key={idx}
				      idx={idx}
				      offset={this.state.offset}
				      rowSize={this.state.rowSize}
			      />
		      ));

		return (
			<div className={"row girls-from-this-post" + (this.props.isCalendar ? " girls-from-this-post--calendar" : " -is-bordered")} ref={this.setContainer}>
				<div className={"girls-from-this-post__title"}>
					{this.props.title}
				</div>
				<div className="girls-from-this-post__body">
					{isLong ? previous : null}
					<div className={"girls-from-this-post__list " + (!isLong ? '-is-centered' : '')}>{avatars}</div>
					{isLong ? next : null}
				</div>
			</div>
		);
	}
}

ActorsFromPost.propTypes = {
	isMobile: PropTypes.bool,
	models:   PropTypes.arrayOf(
		PropTypes.shape({
			name:     PropTypes.string.required,
			age:      PropTypes.number.required,
			isOnline: PropTypes.bool,
			image:    PropTypes.string,
		})
	),
	title:      PropTypes.string.required,
	isCalendar: PropTypes.bool,
};

ActorsFromPost.defaultProps = {
	models:     [],
	isMobile:   false,
	isCalendar: false,
};

ActorsFromPost.ROW_MAX_SIZE      = 5;
ActorsFromPost.ROW_MOBILE_SIZE   = 2;
ActorsFromPost.AVATAR_CARD_WIDTH = 160;

export default ActorsFromPost;
